let navigationGuard = null;

export function registerActivityEditNavigationGuard(handler) {
  navigationGuard = handler;
  return () => {
    if (navigationGuard === handler) navigationGuard = null;
  };
}

export function requestActivityNavigation(to) {
  if (!navigationGuard) return true;
  return navigationGuard(to) !== false;
}
